module.exports = __webpack_public_path__ + "static/media/videoGameMidground.157eefa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/videoGameMidground.png
// module id = 382
// module chunks = 0